import { cn } from '../../lib/cn';

export function Input({ className, label, error, hint, prefix, suffix, ...props }) {
  return (
    <div className="flex flex-col gap-1.5">
      {label && <label className="text-[13px] font-medium text-[var(--text-primary)]">{label}</label>}
      <div className="relative flex items-center">
        {prefix && <span className="absolute left-3 text-[var(--text-tertiary)] pointer-events-none">{prefix}</span>}
        <input
          className={cn(
            'w-full h-10 px-3 bg-[var(--bg-card)] border border-[var(--border)] rounded-[10px] text-[14px] text-[var(--text-primary)] placeholder:text-[var(--text-tertiary)]',
            'focus:outline-none focus:ring-2 focus:ring-[var(--accent)] focus:border-transparent transition-all duration-150',
            'disabled:opacity-50 disabled:cursor-not-allowed',
            error && 'border-[var(--danger)] focus:ring-[var(--danger)]',
            prefix && 'pl-9',
            suffix && 'pr-9',
            className
          )}
          {...props}
        />
        {suffix && <span className="absolute right-3 text-[var(--text-tertiary)] pointer-events-none">{suffix}</span>}
      </div>
      {error && <p className="text-xs text-[var(--danger)]">{error}</p>}
      {hint && !error && <p className="text-xs text-[var(--text-tertiary)]">{hint}</p>}
    </div>
  );
}
